import { memo } from "react"
import PropTypes from "prop-types"
import { Layout } from "./layout.js"
import { ImageButton } from "./image-button.js"
import { RefreshBlue, CloseRed } from "icons"
import { classes, belowViewPort } from "utils"
import { colors } from "design/colors"

const buttonStyle = {
  padding: "9px 6px",
  height: "32px !important",
  width: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}

const iconStyle = { width: 20, height: 14 }
export const PageTitle = memo(
  ({
    title,
    titleStyle,
    className,
    onClose,
    onRefresh,
    hideRefresh,
    hideClose,
  }) => (
    <Layout
      className={classes(className, "page-title")}
      css={{ justifyContent: "space-between", width: "100%", gap: 10 }}
    >
      <h1
        className="title"
        css={[belowViewPort(1441, { fontSize: "1.25rem" }), titleStyle]}
      >
        {title}
      </h1>
      <Layout
        className="page-title-actions"
        css={{ gap: 10, flexWrap: "nowrap" }}
      >
        {!hideRefresh && (
          <ImageButton
            type="reset"
            className="refresh-button"
            title={t("form_header.refresh_tooltip")}
            icon={RefreshBlue}
            css={[
              buttonStyle,
              {
                background: colors.white,
              },
            ]}
            iconStyle={iconStyle}
            onClick={onRefresh}
          />
        )}
        {!hideClose && (
          <ImageButton
            className="close-button"
            title={t("form_header.close_tooltip")}
            icon={CloseRed}
            css={[buttonStyle, { background: colors.white }]}
            iconStyle={{ height: 14, width: 14 }}
            onClick={onClose}
          />
        )}
      </Layout>
    </Layout>
  ),
)

PageTitle.displayName = "PageTitle"

PageTitle.prototype = {
  title: PropTypes.string || PropTypes.element,
  titleStyle: PropTypes.object,
}
